import { useCallback, useMemo } from 'react'

import { Checkbox } from 'core-components/library/checkbox'
import { Flex } from 'core-components/library/flex'

import {
  IEntityManagementSwitcherStateForSaving,
  TEntityManagementSwitcherField,
} from '../../models'

interface IPlanRequiredSwitcherProps {
  changedSwitcherState: IEntityManagementSwitcherStateForSaving[]
  partnerId: string
  initialValue: number
  field: TEntityManagementSwitcherField
  onChange: (value: number) => void
}

export const EntityManagementSwitcher = ({
  changedSwitcherState,
  onChange,
  partnerId,
  field,
  initialValue,
}: IPlanRequiredSwitcherProps) => {
  const flag = useMemo(() => {
    const found = changedSwitcherState.find((el) => el.PartnerId === partnerId)
    return Boolean(found?.[field] ?? initialValue)
  }, [changedSwitcherState, field, initialValue, partnerId])

  const changeHandler = useCallback(
    (flag: boolean) => {
      onChange(Number(flag))
    },
    [onChange]
  )

  return (
    <Flex justifyContent={'center'}>
      <Checkbox checked={flag} onChange={changeHandler} />
    </Flex>
  )
}
